import React from "react";

const SummaryRole = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F6F8FA" />
      <path
        d="M18.3088 27.3088C14.981 26.5415 12.5 23.5603 12.5 20C12.5 15.8578 15.8578 12.5 20 12.5C24.1423 12.5 27.5 15.8578 27.5 20C27.5 23.5603 25.019 26.5415 21.6912 27.3088L20 29L18.3088 27.3088ZM16.259 24.6927C16.9578 25.2516 17.7735 25.6461 18.6455 25.847L19.0655 25.9437L20 26.879L20.9352 25.9437L21.3553 25.8463C22.2842 25.6321 23.1483 25.1985 23.8752 24.5817C23.3869 24.0804 22.8029 23.6821 22.1579 23.4104C21.5128 23.1388 20.8199 22.9992 20.12 23C18.593 23 17.2175 23.6525 16.259 24.6927ZM15.212 23.615C15.8423 22.9461 16.603 22.4133 17.4471 22.0495C18.2912 21.6858 19.2009 21.4988 20.12 21.5C21.0062 21.4988 21.884 21.6728 22.7028 22.0118C23.5216 22.3508 24.2654 22.8482 24.8915 23.4755C25.5336 22.5718 25.9127 21.508 25.9869 20.4019C26.0611 19.2959 25.8275 18.1909 25.3119 17.2096C24.7963 16.2283 24.0189 15.409 23.066 14.8426C22.1131 14.2762 21.0219 13.9849 19.9135 14.0009C18.805 14.017 17.7227 14.3398 16.7866 14.9336C15.8505 15.5273 15.0972 16.3688 14.6103 17.3647C14.1233 18.3605 13.9218 19.4718 14.028 20.5752C14.1342 21.6786 14.544 22.7311 15.212 23.6157V23.615ZM20 20.75C19.2044 20.75 18.4413 20.4339 17.8787 19.8713C17.3161 19.3087 17 18.5456 17 17.75C17 16.9544 17.3161 16.1913 17.8787 15.6287C18.4413 15.0661 19.2044 14.75 20 14.75C20.7956 14.75 21.5587 15.0661 22.1213 15.6287C22.6839 16.1913 23 16.9544 23 17.75C23 18.5456 22.6839 19.3087 22.1213 19.8713C21.5587 20.4339 20.7956 20.75 20 20.75ZM20 19.25C20.3978 19.25 20.7794 19.092 21.0607 18.8107C21.342 18.5294 21.5 18.1478 21.5 17.75C21.5 17.3522 21.342 16.9706 21.0607 16.6893C20.7794 16.408 20.3978 16.25 20 16.25C19.6022 16.25 19.2206 16.408 18.9393 16.6893C18.658 16.9706 18.5 17.3522 18.5 17.75C18.5 18.1478 18.658 18.5294 18.9393 18.8107C19.2206 19.092 19.6022 19.25 20 19.25Z"
        fill="#525866"
      />
    </svg>
  );
};

export default SummaryRole;
